import {useTheme} from '@mui/material';
import {FeaturesEnum} from 'presentation/constants';
import {usePrint} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {useCalendarEvent} from 'presentation/modules/booking/shared/hooks/useCalendarEvent';
import {useMediaQueries} from 'presentation/pages';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {getAllMonths} from 'presentation/utils';

export function useTelehealthConfirmationBookingContent(
	bookedAppointment: AppointmentsHomeStateType,
) {
	const {isMobile, isTablet, betweenMobileAndDesktop, isDesktop} = useMediaQueries();
	const {isPrinting, printContent, printRef} = usePrint();
	const {iconName, alertTitle} = useBookingTheme({flowType: FlowEnum.TELEHEALTH});
	const calendarEvent = useCalendarEvent(bookedAppointment);
	const {colors} = useTheme();

	const {isEnabled: isUploadFileTeleFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_UPLOAD_FILE_TELE,
	);

	const {
		formattedDateWithWeekday,
		hour,
		date,
		phoneNumbers,
		providerName,
		specialtyName,
		protocolNumber,
		bookingNumber,
	} = bookedAppointment;

	const [day, month] = date.split(' ')[0].split('/');
	const months = getAllMonths();
	const monthName = months[Number(month) - 1].slug;
	const hasPhoneNumbers = phoneNumbers && phoneNumbers.length !== 0;

	return {
		isMobile,
		isTablet,
		betweenMobileAndDesktop,
		isPrinting,
		printContent,
		printRef,
		iconName,
		alertTitle,
		calendarEvent,
		colors,
		formattedDateWithWeekday,
		hour,
		phoneNumbers,
		providerName,
		specialtyName,
		protocolNumber,
		day,
		monthName,
		hasPhoneNumbers,
		isDesktop,
		bookingNumber,
		isUploadFileTeleFeatureFlagEnabled,
	};
}
